/* eslint-disable eqeqeq */
import more from '../icons/menu/more.svg'
import tasks from '../icons/menu/tasks.svg'
import profile from '../icons/menu/profile.svg'
import need_rework from '../icons/menu/need_rework.svg'
import chats from '../icons/menu/chats.svg'
import { useState, useLayoutEffect } from 'react';
import { getIsIosApp, Pages } from '../pages_android/custom_views/insta_custom_views/utils_android/UtilsAndroid';
import BottomMenuItem from './custom_views/BottomMenuItem';
import NeedReworkMenuItem from './custom_views/NeedReworkMenuItem';
import ChatsMenuItem from './custom_views/ChatsMenuItem';
import { getCookie } from '../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper';
import { getUrlParameter } from '../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid';

function BottomMenu(props) {
    const [currentLink, setCurrentLink] = useState(Pages.experts)
    const activeCount = props.needReworkTasks.length
    // useLayoutEffect, а не useEffect: отступ для системной навигации Android 15/16
    // ставится до первой отрисовки — меню не «подпрыгивает» после появления.
    useLayoutEffect(() => {
        setCurrentLink(Pages.tasks)
       function fixForAndroid16Navigation() {
            const el = document.getElementsByClassName('bottom_menu_container')[0];
            if (!el) return;

            const ua = navigator.userAgent || '';

            // Проверка Android 4.1/4.2 и WebView
            const isAndroid16 = /Android 16/i.test(ua);
            const isAndroid15 = /Android 15/i.test(ua);
            const isWebView = /; wv\)/i.test(ua) || /Version\/\d+\.\d+ Chrome\/\d+\.\d+\.\d+\.\d+ Mobile Safari\/\d+/i.test(ua);

            if ((isAndroid16 || isAndroid15) && isWebView) {
            // Добавляем фиксированный нижний отступ, чтобы не попадать под кнопки
                el.style.paddingBottom = '48px'; // Можешь подстроить: 48px — типичная высота нижней панели
            }
            
        }
        if(!getCookie("webview_fits") && getUrlParameter("webview_fits") != "true" && getCookie("platform") != "ios" && getUrlParameter("platform") != "ios" && !getIsIosApp()){
            fixForAndroid16Navigation()
        }
        // Вызов при загрузке
        // window.addEventListener('load', adjustBottomInsetForNavigation);
    }, [])
    const user = props.user
  
    return (
        <div id='bottom_menu_container' className="bottom_menu_container">
            <BottomMenuItem setCurrentLink={setCurrentLink} link={Pages.tasks} title="Задания" icon={tasks}/>
            <NeedReworkMenuItem activeCount={activeCount} setCurrentLink={setCurrentLink} link={Pages.need_rework} title="Доработки" icon={need_rework}/>
            <ChatsMenuItem unread={props.chatUnread} setCurrentLink={setCurrentLink} link={Pages.chats} title="Чаты" icon={chats}/>
            <BottomMenuItem setCurrentLink={setCurrentLink} link={Pages.profile} title="Профиль" icon={profile}/>
            <BottomMenuItem setCurrentLink={setCurrentLink} link={Pages.more} title="Ещё" icon={more}/>
        </div>
    );
}

export default BottomMenu;

